/** The player's note when no reply can be written (the server's 409 "uncharted": app.ts restingReply). */

/** When replies come back, on the player's own clock: "8:00 pm", "midnight", "9:00 am tomorrow". */
export function backAt(until: number, now = Date.now()): string {
  const d = new Date(until), h = d.getHours(), m = d.getMinutes();
  if (h === 0 && m === 0) return "midnight";
  const time = `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h < 12 ? "am" : "pm"}`;
  return new Date(now).toDateString() === d.toDateString() ? time : `${time} tomorrow`;
}

/** Why no reply can be written (the server's `resting`, owner-approved wording 2026-10-21), and when it comes back. */
export function restingNote(body: Record<string, unknown>, now = Date.now()): string {
  const saved = "Your story is saved, and this didn't use one of your turns.";
  if (body.resting === "paused") {
    return `Weftwake has paused new replies while we look into a problem. ${saved} You can still read your stories and your Journal. Replies will come back as soon as it's fixed.`;
  }
  const at = backAt(typeof body.until === "number" ? body.until : (Math.floor(now / 86_400_000) + 1) * 86_400_000, now);
  if (body.resting === "free") {
    return `Free play has reached today's limit, so Weftwake can't write new replies for free players until ${at}. ${saved} Patrons keep playing today.`;
  }
  return `Weftwake has reached today's limit, so it can't write new replies for anyone until ${at}. ${saved} You can still read your stories and your Journal.`;
}
